import { useEffect, useState } from "react";
import { normalizeProgram } from "../pages/findprogram"; 

const CLINIC_ID = "6a3ba96dc8e05c65af7f0ef0";
const PROGRAMS_API = `https://api.avexa.net/clinic-onboarding/clinics/${CLINIC_ID}/programs`;

export const usePrograms = () => {
  const [programs, setPrograms] = useState([]);
  const [lifeStages, setLifeStages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const response = await fetch(PROGRAMS_API);

        if (!response.ok) {
          throw new Error("Failed to fetch programs");
        }

        const data = await response.json();

        const raw = Array.isArray(data)
          ? data
          : data.programs ?? [];

        const normalized = raw.map(normalizeProgram);

        setPrograms(normalized);

        const seen = new Map();

        raw.forEach((p) =>
          p.lifeStages?.forEach((ls) => {
            if (!seen.has(ls.id)) {
              seen.set(ls.id, ls);
            }
          })
        );

        setLifeStages([...seen.values()]);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrograms();
  }, []);

  return {
    programs,
    lifeStages,
    loading,
    error,
  };
};